
/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetTrialsMetadata, GetTrialsMetadataResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetTrialsMetadataResponse, GetTrialsMetadataResponse>) => response?.data?.trials;
const getError = (response?: SWRResponse<GetTrialsMetadataResponse, GetTrialsMetadataResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetTrialsMetadataResponse, GetTrialsMetadataResponse>) => ({});

const useGetTrialsMeta = (query?: Partial<GetTrialsMetadata>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetTrialsMetadata(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetTrialsMeta;